import * as _ from 'underscore';

export const defaultGalleryConfig = {
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 600,
    dots: true,
    arrows: true,
    asNavFor: null,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    centerMode: false,
    centerPadding: '50px',
    mobileFirst: true,
    focusOnSelect: false,
    touchMove:false,
    rows: 0,
    responsive: [],
    draggable: false,
    dotsClass:"gallery__dots",
    prevArrow:"<button class='gallery__nav--prev'>Prev</button>",
    nextArrow:"<button class='gallery__nav--next'>Next</button>",
};

export const galleryConfigs = [
    {
        type: 'hero',
        config: {
            arrows: false,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnFocus: false,
            pauseOnHover: false,
            touchMove: true,
            draggable: true,
            swipe: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true
                    }
                }
            ]
        }
    },
    {
        type: 'panel',
        config: {
            arrows: false,
            autoplay: true,
            autoplaySpeed: 10000,
            swipe: true,
            dots: true, // true if you want the pager e.g. 1/3
            swipeToSlide: true,
            dotsClass: 'gallery__pager',
            customPaging : function(slider, i) {
                return (i + 1) + '/' + slider.slideCount;
            },
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: true,
                        swipeToSlide: false,
                    }
                }
            ]
        }
    },
    {
        type: "calendar",
        config: {
            arrows: false,
            dots: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        dots: true,
                        swipe: false,
                        swipeToSlide: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        }
    },
    {
        type: "categories",
        config: {
            arrows: false,
            dots: false,
            infinite: false,
            prevArrow:"<button class='gallery__nav--prev'><i class=\"icon icon-chevron-left\"></i></button>",
            nextArrow:"<button class='gallery__nav--next'><i class=\"icon icon-chevron-right\"></i></button>",
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        dots: false,
                        swipe: false,
                        swipeToSlide: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        }
    },
    {
        type: 'jumbo',
        config: {
            arrows: false,
            centerMode: true,
            centerPadding: '10px',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        centerPadding: '235px',
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        centerPadding: '40px',
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        centerPadding: '40px',
                    }
                }
            ]
        }
    },
    {
        type: "festival",
        config: {
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        }
    },
    {
        type: "event-modal",
        config: {
            dots: false,
            arrows: false,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                }]
        }
    }, {
        type: "timeline",
        config: {
            dots: false,
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dots: true,
                        arrows: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }]
        }
    }, {
        type: "media",
        config: {
            dots: false,
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dots: true,
                        arrows: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }]
        }
    }, {
        type: "additional-performances",
        config: {
            arrows: true,
            dots: false,
            infinite: false,
            variableWidth: true,
            touchMove: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        dots: true,
                        swipe: false,
                        swipeToSlide: false,
                        variableWidth: false,
                        touchMove: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        variableWidth: false,
                        touchMove: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        variableWidth: false,
                        touchMove: false,
                    }
                }
            ]
        }
    },
    {
        type: "associated-events",
        config: {
            arrows: true,
            dots: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: true
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        dot: true
                    }
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        dot: true
                    }
                }
            ]
        }
    },
    {
        type: "search-results-events",
        config: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1.25,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2.25,
                        slidesToScroll: 2,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                    },
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                    },
                },
            ],
        },
    },
    {
        type: "blog-scroller",
        config: {
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            prevArrow:"<button class='blog-scroller__nav blog-scroller__nav--prev'>Prev</button>",
            nextArrow:"<button class='blog-scroller__nav blog-scroller__nav--next'>Next</button>",
            responsive: [
                {
                    breakpoint: 0,
                    settings: "unslick"
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 2
                    },
                },
                {
                    breakpoint: 1020,
                    settings: {
                        slidesToShow: 3.5,
                        slidesToScroll: 2
                    },
                },
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 4.5,
                        slidesToScroll: 2
                    },
                },
            ],
        },
    },
];

export function getGalleryConfig(type: string): object {
    const foundConfig = _.find(
           galleryConfigs, (config) => config.type === type);

    let galleryConfig = foundConfig ? foundConfig.config : {};
    const config = _.defaults(galleryConfig, defaultGalleryConfig);

    return config;
}

export default getGalleryConfig;



// WEBPACK FOOTER //
// ./@modules/config/gallery-config.ts